import useSWR, { SWRConfiguration } from 'swr'
import { useSelector } from 'react-redux'
import { RootState } from 'store/modules/rootReducer'
import { learningApi } from 'services/api'
import { toast } from 'react-toastify'

export function useGetIsSocialCampaign() {
  const token = localStorage.getItem('token')
  const { profile } = useSelector((state: RootState) => state.student)

  const url = `/content/monitoring/get-order-by-slug`

  const key = token && profile._id ? [url, token, profile._id] : null

  return useSWR(key, fetcher, configuration)
}

const fetcher = ([url, token, studentId]: [string, string, string]) =>
  learningApi
    .post(
      url,
      {
        studentId,
        campaignId: [
          '644bf990148bad0035b6edee',
          '644bfdc9148bad0035b6ee79',
          '644c196860048b00338bd40c',
        ],
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((res) => res.data)

const configuration: SWRConfiguration = {
  fallbackData: { showMessage: false },
  shouldRetryOnError: true,
  onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
    if (retryCount > 3) {
      toast.error('Não foi possível carregar suas Campanhas. Tente novamente mais tarde.')
    } else {
      setTimeout(() => revalidate({ retryCount }), 1000)
    }
  },
  keepPreviousData: true,
  dedupingInterval: 60e3,
  revalidateOnReconnect: true,
}
